import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';

import { isEmpty } from 'lodash';
import { useTranslation } from '@lt/localization';
import styles from './container.module.css';

import { getFiltersFromUrl } from '../../../../utils';

const Styles = {
  position: 'relative',
  flexDirection: 'column',
  display: 'flex',
  width: '100vw',
  height: '100vh',
  margin: 0,
  padding: 0,
  zIndex: 9999,
};

export const Container = (props) => {
  const { children, isMobile, isOpen, onCancel, clearFilters, cancelFilters } =
    props;
  const hasFilters = !isEmpty(getFiltersFromUrl());

  const { t } = useTranslation();

  const handleCancel = () => {
    cancelFilters();

    if (!onCancel) return;
    onCancel();
  };

  return isMobile ? (
    <Modal
      open={isOpen}
      styles={{ modal: Styles, overlay: { padding: 0, zIndex: 9999 } }}
      showCloseIcon={false}
      onClose={handleCancel}
    >
      <div className={styles.wrapper}>
        <button
          className={styles.cancelButton}
          type="button"
          onClick={handleCancel}
        >
          {t('filters.panel.cancel')}
        </button>

        {hasFilters && (
          <button
            className={styles.clearButton}
            type="button"
            onClick={clearFilters}
          >
            {t('filters.clearbutton.desktop')}
          </button>
        )}

        {children}
      </div>
    </Modal>
  ) : (
    <div>{children}</div>
  );
};

Container.propTypes = {
  children: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  containerRef: PropTypes.shape({}).isRequired,
};
